import { render, staticRenderFns } from "./lv-column-group.vue?vue&type=template&id=5a3503de&"
import script from "./lv-column-group.vue?vue&type=script&lang=js&"
export * from "./lv-column-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports